import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import AuthService from '../../services/AuthService';
import Loader from '../../components/Loader';
import SubnavBar from '../../components/SubnavBar';
import TitleBar from '../../components/TitleBar';
import List from '../../components/Companies/List';
import { CompanyActions } from '../../actions';

export class Companies extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  static propTypes = {
    auth: PropTypes.instanceOf(AuthService)
  }

  componentWillMount() {
    const { companies } = this.props;
    if (!companies) {
      this.props.dispatch(CompanyActions.getAllCompanies());
    }
  }

  newCompany = () => {
    browserHistory.push('/admin/company');
  }

  render() {
    const { companies } = this.props;
    const subnavItems = [{ key: 1, label: 'New', onClick: this.newCompany }];
    let content;
    if (!companies || companies.fetching || !companies.list) {
      content = <Loader />;
    } else {
      content = <List companies={companies.list} />
    }

    return (
      <div className="grid">
        <div className="unit whole align-center">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Companies" />
          <div className="grid">
            <div className="unit whole">
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { companies } = state;
  return {
    companies
  }
}

export default connect(mapStateToProps)(Companies);


// WEBPACK FOOTER //
// ./src/containers/Companies/index.js